<script lang="typescript">
  export let noLeads = false;

  $: win = noLeads ? 'Lead' : 'Win';
</script>

<div class="legend-holder">
  <div class="party-key">
    <span class="bold">Dem.</span>
    <span class="key-color d-win"></span> {win}
    {#if !noLeads}<span class="key-color d-lead"></span>Lead{/if}
  </div>

  <div class="party-key">
    <span class="bold">Rep.</span>
    <span class="key-color r-win"></span>{win}
    {#if !noLeads}<span class="key-color r-lead"></span>Lead{/if}
  </div>
</div>
